import { render, staticRenderFns } from "./PosTip.vue?vue&type=template&id=11299f14&scoped=true"
import script from "./PosTip.vue?vue&type=script&lang=js"
export * from "./PosTip.vue?vue&type=script&lang=js"
import style0 from "./PosTip.vue?vue&type=style&index=0&id=11299f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11299f14",
  null
  
)

export default component.exports